document.addEventListener('DOMContentLoaded', function(){
    const form = document.querySelector('#Contact_static-newsletter-sms-collection');
    const btnSubmit = document.querySelector('[name="btnSubmit"]');
    const formDefaultElements = document.querySelector('.custom-form-elements');
    const formDefault = document.querySelector('.form-customer__default');
    const formSuccess = document.querySelector('.form-customer__success');
    const formError = document.querySelector('#custom-form-error');
    const formErrorText = document.querySelector('#custom-form-error span');
    const formEmailError = document.querySelector('.custom-email-error');
    const formPhoneError = document.querySelector('.custom-phone-error');

    if(!!!form) return 
    
    form.addEventListener('submit', formSubmitHandler)

    async function formSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        toggleClassElements(formEmailError, true, 'hidden')
        toggleClassElements(formPhoneError, true, 'hidden')
        toggleClassElements(formError, true, 'hidden')
        toggleClassElements(formSuccess, true, 'hidden')
        toggleClassElements(formDefault, false, 'hidden')
        
        if(btnSubmit) btnSubmit.textContent = theme.strings.newsletterButton
        if(formErrorText) formErrorText.textContent = ''
    
        const inputEmail = form.elements['contact[email]'];
        const inputPhone = form.elements['contact[tags]'];
    
        if(inputEmail.value.trim() === '') toggleClassElements(formEmailError, false, 'hidden')
        if(inputPhone.value.trim() === '') toggleClassElements(formPhoneError, false, 'hidden')
        if(inputEmail.value.trim() === '' || inputPhone.value.trim() === '') return

        const formValues = {
            email: inputEmail.value,
            phone: inputPhone.value
        }

        try {
            if(btnSubmit) btnSubmit.textContent = theme.strings.loading + '...'
            const res = await sendCustomerInformation(formValues)

            toggleClassElements(formSuccess, false, 'hidden')
            toggleClassElements(formDefault, true, 'hidden')
            toggleClassElements(formDefaultElements, true, 'hidden')

            if(btnSubmit) btnSubmit.textContent = theme.strings.newsletterButton

            return res
        } catch(err) {
            console.log(err)

            if(btnSubmit) btnSubmit.textContent = theme.strings.newsletterButton
            const errorMessages = err?.error?.response?.body?.errors ? Object.entries(err?.error?.response?.body?.errors) : []
            const errorMessage = errorMessages.map(([key, value]) => `<div>${key}: ${value}</div>`)

            toggleClassElements(formError, true, 'flex')
            if(formErrorText){
                if(errorMessage.length > 0) formErrorText.innerHTML = errorMessage.join(' ')
                else formErrorText.textContent = 'Something went wrong.'
            } 

            return
        }
    }

    async function sendCustomerInformation(data){
        const request = await fetch('https://ztiariz2j64t6ca7vapyxy2arm0vfxwj.lambda-url.us-east-1.on.aws/v1/customer', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })

        const response = await request.json();

        if(request.status >= 400) throw response

        return response;
    }

    function toggleClassElements(element, action, value) {
        if(!!element) element.classList.toggle(value, action)
    }
})